import { render, staticRenderFns } from "./edit-model.vue?vue&type=template&id=34a4600d&scoped=true&"
import script from "./edit-model.vue?vue&type=script&lang=js&"
export * from "./edit-model.vue?vue&type=script&lang=js&"
import style0 from "./edit-model.vue?vue&type=style&index=0&id=34a4600d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a4600d",
  null
  
)

export default component.exports